import React from 'react';
import AnimatedSection from '../common/AnimatedSection';

const CompanyInfo = () => {
  return (
    <section className="py-24 bg-white border-t border-dark/[0.03]">
      <div className="max-w-7xl mx-auto px-6 lg:px-8">
        <div className="grid lg:grid-cols-2 gap-20 items-center">
          
          {/* left: visual/ad placement */}
          <AnimatedSection>
            <div className="relative group">
              {/* decorative frame */}
              <div className="absolute -inset-4 border border-primary/20 rounded-[3rem] scale-95 group-hover:scale-100 transition-transform duration-700" />
              
              <div className="relative aspect-square md:aspect-video lg:aspect-[4/5] rounded-[2.5rem] overflow-hidden bg-slate-100 shadow-2xl shadow-dark/5">
                {/* this is where an ad image or company photo goes */}
                <img 
                  src="https://images.unsplash.com/photo-1497366216548-37526070297c?auto=format&fit=crop&q=80&w=1200" 
                  alt="company culture"
                  className="w-full h-full object-cover transition-transform duration-1000 group-hover:scale-110"
                />
                
                {/* glass overlay for 'ad' feel */}
                <div className="absolute bottom-8 left-8 right-8 p-6 bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl">
                  <p className="text-white text-xs font-black uppercase tracking-widest mb-1">partner spotlight</p>
                  <p className="text-white/80 text-[10px] font-medium leading-relaxed">
                    driving innovation through strategic global partnerships.
                  </p>
                </div>
              </div>
            </div>
          </AnimatedSection>

          {/* right: info / process text */}
          <div className="space-y-12">
            <AnimatedSection delay={0.2}>
              <span className="text-primary text-xs font-black uppercase tracking-[0.3em] block mb-4">
                how we operate
              </span>
              <h2 className="text-4xl md:text-5xl font-bold text-dark leading-tight tracking-tight">
                expertly crafted <span className="text-primary">experiences</span> for growth.
              </h2>
            </AnimatedSection>

            <div className="space-y-8">
              {[
                { title: 'curated methodology', desc: 'our events are built on a framework of practical application and industry foresight.' },
                { title: 'global network', desc: 'we connect leading financial experts from kathmandu to bengaluru and beyond.' },
                { title: 'company vision', desc: 'empowering professionals to lead with confidence in a digital-first economy.' }
              ].map((item, i) => (
                <AnimatedSection key={i} delay={0.3 + (i * 0.1)}>
                  <div className="flex gap-6 group">
                    <div className="flex-shrink-0 w-12 h-12 rounded-2xl bg-slate-50 border border-dark/[0.03] flex items-center justify-center text-primary font-black group-hover:bg-primary group-hover:text-white transition-all duration-500">
                      0{i + 1}
                    </div>
                    <div>
                      <h4 className="text-lg font-bold text-dark mb-2 uppercase tracking-wide">{item.title}</h4>
                      <p className="text-dark/50 text-sm leading-relaxed lowercase">{item.desc}</p>
                    </div>
                  </div>
                </AnimatedSection>
              ))}
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default CompanyInfo;